module.exports = __webpack_public_path__ + "img/pin-start.53840ac7.svg";